class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.sentinel = document.querySelector("[data-back-to-top-sentinel]");
    this.btn = this.querySelector(".back-to-top__button");

    if (!this.sentinel || !this.btn) return;
  }

  connectedCallback() {
    this.scrollObserver();

    this.btn.addEventListener("click", () => {
      this.scrollToTop();

      // Shift focus to first focusable element in header depending on screen size
      if (this._isMobile) {
        document.querySelector(".header__below .header__cart-icon")?.focus();
      } else {
        const allNavItems = document.querySelectorAll(".header__main-nav-link");
        allNavItems[allNavItems.length - 1]?.focus();
      }
    });
  }

  scrollObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.classList.toggle("visible", !entry.isIntersecting);
      });
    });

    this.observer.observe(this.sentinel);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("component-back-to-top")) {
  customElements.define("component-back-to-top", BackToTop);
}
